//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { EventBus } from '../../../EventBus/EventBus'
import { formatConfiguredTime } from '../../../components/helpers.js'
import { axiosPost } from '../../../axios/axios.js'

import { technologicalOperationHasResult } from './ReportCheckListTechnologicalOperationHasResult.js'
import ReportCheckListWorkResultsType from './ReportCheckListWorkResultsTypes.vue/ReportCheckListWorkResultsTypes.vue'
import ReportRemarkImportantCheckbox from '../ReportRemarkImportantCheckbox.vue'
import ReportCheckListCheckbox from './ReportCheckListCheckbox.vue'
import { LABEL_MARKS } from '../../Request/RequestWorkTypes.js'
import ReportCheckListHistoryRecords from './ReportCheckListHistoryRecords.vue'

export default {
  name: 'ReportCheckListTechnologicalOperation',
  components: {
    ReportCheckListWorkResultsType,
    ReportCheckListCheckbox,
    ReportRemarkImportantCheckbox,
    ReportCheckListHistoryRecords
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    workPackage: {
      type: Object,
      default: null
    },
    workType: {
      type: Object,
      required: true
    },
    technologicalOperation: {
      type: Object,
      default () {
        return {}
      }
    },
    allWorkPackages: {
      type: Array,
      default () {
        return []
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    setup: {
      type: Boolean,
      default: false
    },
    openAll: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    },
    showPreviousDepartures: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      opened: false,
      showCommentField: false,
      isNew: false,
      timingStateRecord: null,
      technologicalOperationMark: LABEL_MARKS.technologicalOperation,
      workTypeMark: LABEL_MARKS.workType,
      workPackageMark: LABEL_MARKS.workPackage,
      formatConfiguredTime: formatConfiguredTime
    }
  },
  computed: {
    timingState: function () {
      return this.timingStateRecord && this.timingStateRecord.timingState || null
    },
    timingStateBtnConfig: function () {
      const state = this.timingState
      if (state === 'notStarted') {
        return {
          label: 'Старт',
          tooltip: 'Начать выполнение',
          icon: 'mdi-play',
          nextTimingState: 'started'
        }
      } else if (state === 'started') {
        return {
          label: 'Стоп',
          tooltip: 'Завершить выполнение',
          icon: 'mdi-stop',
          nextTimingState: 'finished'
        }
      } else if (state === 'finished') {
        return {
          label: 'Продолжить',
          tooltip: 'Продолжить выполнение',
          icon: 'mdi-play',
          nextTimingState: 'started'
        }
      }
      return null
    },
    displayTimingStateBtn: function () {
      return !!(this.timingStateBtnConfig && this.report.operationTimingsActive && this.reportActionsAccess.changeOperationTimingState)
    },
    technologicalOperationHasResult: function () {
      return technologicalOperationHasResult(this.technologicalOperation, this.report, this.workType) // TODO technologicalOperation.hasResult - сделать вычисляемым свойством самой операции
    },
    technologicalOperationAdditionalStyle () {
      if (this.setup) {
        return ''
      }

      const {
        technologicalOperation,
        technologicalOperationHasResult,
        workType,
        roleExecutor
      } = this

      let styles = ''

      if (!workType.includedInCurrentReport) {
        return 'background-color: #e0e0e0;'
      } else if (technologicalOperation.remark) {
        styles += 'background-color: #fce5e3;'
      } else if (technologicalOperation.done) {
        styles += 'background-color: rgba(152,251,152,0.5);'
      }

      if (!roleExecutor) {
        return styles
      }

      const requiredNotDone = technologicalOperation.required && !technologicalOperation.done
      const resultsRequiredNotDone = technologicalOperation.resultsRequired && !technologicalOperationHasResult

      if (requiredNotDone || resultsRequiredNotDone) {
        const errorBorder = 'border: 1px solid rgb(255,0,0); box-shadow: 0px 0px 1px 1px rgba(255,0,0,0.5);'
        const warningBorder = 'border: 1px solid rgb(255,165,0); box-shadow: 0px 0px 1px 1px rgba(255,165,0,0.5);'

        const hasNoComments = !technologicalOperation.comment && !workType.comment
        styles += hasNoComments ? errorBorder : warningBorder
      }

      return styles
    },
    hasComment: function () {
      return this.technologicalOperation.comment && this.technologicalOperation.comment != ''
    }
  },
  watch: {
    openAll: function (result) {
      if (result) {
        this.opened = true
      } else {
        this.opened = false
      }
      sessionStorage.setItem(this.technologicalOperation.id.toString() + this.report.id + '_opened', this.opened)
    },
    'technologicalOperation.done': function (result) {
      if (!this.workType.includedInCurrentReport) {
        return
      }
      this.$emit('technological-operation-done-changed', this.technologicalOperation)
    },
    'technologicalOperation.workResultsTypes': {
      handler: function () {
        this.updateDoneValue()
      },
      deep: true
    }
  },
  created: function () {
    if (this.workType.isNew) {
      this.isNew = true
    }
    this.timingStateRecord = this.report.operationTimings.find(record => record.executor === this.workType.executorTypeKey &&
    record.workKey === this.workType.key &&
    record.operationKey === this.technologicalOperation.key
    )
    if (!this.timingStateRecord) {
      this.timingStateRecord = {
        executor: this.workType.executorTypeKey,
        workKey: this.workType.key,
        operationKey: this.technologicalOperation.key,
        timingState: 'notStarted'
      }
      this.report.operationTimings.push(this.timingStateRecord)
    }

    if (!sessionStorage.getItem(this.technologicalOperation.id.toString() + this.report.id + '_opened')) {
      if (this.technologicalOperation.remark) {
        this.opened = true
      }
      if (this.openAll) {
        this.opened = true
      }
    } else {
      this.opened = sessionStorage.getItem(this.technologicalOperation.id.toString() + this.report.id + '_opened') === 'true'
    }
    EventBus.$on('task-closed', this.clearSessionStorage)
  },
  beforeDestroy: function () {
    EventBus.$off('task-closed', this.clearSessionStorage)
  },
  methods: {
    getFullWorkTypesCount: function (workPackage) {
      const rawWorkPackage = this.allWorkPackages.find(wP => wP.id === workPackage.id)
      return rawWorkPackage.workTypes.length
    },
    updateDoneValue: function () {
      if (!this.workType.includedInCurrentReport) {
        return
      }
      this.technologicalOperation.done = !!this.technologicalOperationHasResult
    },
    clearSessionStorage: function () {
      sessionStorage.removeItem(this.technologicalOperation.id.toString() + this.report.id + '_opened', this.opened)
    },
    commentChanged: function (comment) {
      this.$emit('technological-operation-comment-changed', comment)
    },
    onDeleteComment: function () {
      this.technologicalOperation.comment = ''
      this.showCommentField = false
      this.$emit('technological-operation-comment-changed', this.technologicalOperation.comment)
    },
    onTechnologicalOperationHeaderName: function () {
      this.opened = !this.opened
      sessionStorage.setItem(this.technologicalOperation.id.toString() + this.report.id + '_opened', this.opened)
    },
    onRemarkChanged: function (result) {
      if (!this.setup) {
        this.$set(this.technologicalOperation, 'remark', result)
        if (!result) {
          this.technologicalOperation.remarkComment = null
        }
        this.$emit('remark-changed')
      }
    },
    onDuplicate: function () {
      this.$emit('duplicate', this.technologicalOperation)
    },
    onChangeTimingState: function () {
      if (this.isNew) {
        const message = 'Для начала выполнения сохраните добавленную работу'
        this.$q.notify({
          type: 'warning',
          message: message,
          progress: true,
          timeout: 5000
        })
        return Promise.reject(new Error(message))
      }

      const timingStateRecord = this.timingStateRecord
      const config = this.timingStateBtnConfig

      // TODO завершение другой активной операции
      // let activeOperationTiming
      // if (config.nextTimingState === 'started') {
      //   const activeOperationTimings = this.report.operationTimings.filter(record => record.timingState === 'started')
      //   if (activeOperationTimings.length) {
      //     if (activeOperationTimings.length > 1) {
      //       this.$q.notify({
      //         type: 'negative',
      //         message: 'Некорректный список состояний операций',
      //         progress: true,
      //         timeout: 5000
      //       })
      //       return
      //     } else if (activeOperationTimings.length === 1) {
      //       activeOperationTiming = activeOperationTimings[0]
      //       if (activeOperationTiming === timingStateRecord) {
      //         activeOperationTiming = null
      //       }
      //     }
      //   }
      // }

      const bodyFormData = new FormData()
      bodyFormData.set('reportId', this.report.id)
      bodyFormData.set('executor', timingStateRecord.executor)
      bodyFormData.set('workKey', timingStateRecord.workKey)
      bodyFormData.set('operationKey', timingStateRecord.operationKey)
      bodyFormData.set('timingState', config.nextTimingState)

      return axiosPost({
        url: '/service/delta/report/changeOperationTimingState',
        data: bodyFormData,
        onSuccess: (response) => {
          this.timingStateRecord.timingState = config.nextTimingState

          const responseData = response.data
          if (responseData) {
            const messages = []
            if (responseData.updated === false) {
              if (this.timingStateRecord.timingState === 'started') {
                messages.push('Таймер уже был запущен')
              } else {
                messages.push('Таймер уже был остановлен')
              }
            }

            if (responseData.changeTime != null && this.report.changeTime != null && this.report.changeTime < responseData.changeTime) { // Может быть обратное, если данный запрос подвис и его опередил следующий
              this.report.changeTime = responseData.changeTime

              if (responseData.operationTimings != null) {
                let otherTimingsUpdated = false
                for (const operationTiming of responseData.operationTimings) {
                  const timingStateRecord = this.report.operationTimings.find(record => record.executor === operationTiming.executor &&
                    record.workKey === operationTiming.workKey &&
                    record.operationKey === operationTiming.operationKey
                  )
                  if (timingStateRecord && timingStateRecord !== this.timingStateRecord) {
                    if (timingStateRecord.timingState !== operationTiming.timingState) {
                      timingStateRecord.timingState = operationTiming.timingState
                      otherTimingsUpdated = true
                      console.log('update timing', timingStateRecord)
                    }
                  }
                }
                if (otherTimingsUpdated) {
                  messages.push('Обновлены состояния всех таймеров')
                }
              // this.report.operationTimings = responseData.operationTimings
              }
            }

            if (messages.length) {
              this.$q.notify({
                type: 'warning',
                message: messages.join('.\n'),
                progress: true,
                timeout: 5000
              })
            }
          }

          // if (activeOperationTiming) { // TODO проверить, что на сервере это тоже выполняется !
          //   activeOperationTiming.timingState = 'finished'
          // }
        },
        onFailure: response => {
          const message = response.message || 'Ошибка изменения статуса выполнения операции'
          this.$q.notify({
            type: 'negative',
            message: message,
            progress: true,
            timeout: 5000
          })
          throw new Error(message)
        }
      })
    }
  }
}

